module.exports = __webpack_public_path__ + "img/stop_btn.0eb26e54.png";